export default __webpack_public_path__ + "static/media/leaflet-marker-green.3b9f06df.svg";